import type { Components, Theme } from '@mui/material/styles';

export const MuiTableSortLabel: Components<Theme>['MuiTableSortLabel'] = {
	styleOverrides: {
		root: {
			'&.Mui-active': {
				color: 'var(--accent)',
			},
			'&.Mui-active .MuiTableSortLabel-icon': {
				color: 'var(--accent)',
			},
		},
	},
};
